import { ListBox, Select } from "@heroui/react";
import { Controller, type Control } from "react-hook-form";
import type { RecipesFilterFormValues } from "../RecipesFilterContainer";
import type { RecipeCategory } from "@/hooks/useGetRecipeCategories";
import { FilterFieldShell } from "./FilterFieldShell";

interface RecipeCategoryFilterProps {
    control: Control<RecipesFilterFormValues>;
    recipeCategories: RecipeCategory[];
    onApply(): void;
}

export const RecipeCategoryFilter = ({ control, recipeCategories, onApply }: RecipeCategoryFilterProps) => {
    return (
        <FilterFieldShell label="Category">
            <Controller
                name="recipeCategoryNames"
                control={control}
                render={({ field }) => {
                    const values = (field.value as string[]) ?? [];

                    return (
                        <Select
                            className="w-full"
                            variant="secondary"
                            selectionMode="multiple"
                            placeholder="Any"
                            value={values}
                            onChange={(keys) => {
                                field.onChange(keys as string[]);
                                queueMicrotask(onApply);
                            }}
                            aria-label="Recipe category"
                        >
                            <Select.Trigger className="w-full">
                                <Select.Value>
                                    {({ defaultChildren, isPlaceholder, state }) => {
                                        const items = state.selectedItems;
                                        if (isPlaceholder || items.length === 0) return defaultChildren;
                                        if (items.length === 1) return items[0]?.textValue ?? defaultChildren;
                                        return `${items.length} selected`;
                                    }}
                                </Select.Value>
                                <Select.Indicator />
                            </Select.Trigger>
                            <Select.Popover>
                                <ListBox selectionMode="multiple">
                                    {recipeCategories.map((category) => (
                                        <ListBox.Item key={category.name} id={category.name} textValue={category.name}>
                                            {category.name}
                                            <ListBox.ItemIndicator />
                                        </ListBox.Item>
                                    ))}
                                </ListBox>
                            </Select.Popover>
                        </Select>
                    );
                }}
            />
        </FilterFieldShell>
    );
};
